import { Component, OnInit } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';
import { EditorService } from '../services/editor.service';
import { LayoutInputComponent } from './layout-input/layout-input.component';
import { DynamicInputComponent,MenuGroup } from '../dynamic-input-model';

@Component({
  selector: 'ngx-layout-editor',
  templateUrl: './layout-editor.component.html',
  styleUrls: ['./layout-editor.component.scss']
})
export class LayoutEditorComponent implements OnInit {
  //initiallyCollapsed = true;
  //showSubmenu = false;
  menuGroups:any;
  title = "Editing Layout";
  menuTag = "editLayoutMenu";
  inputComponent = new DynamicInputComponent(LayoutInputComponent);
  menuGroup:MenuGroup = {
    title:"Editing Layout",
    menuTag:"editLayoutMenu",
    menuItems: [
      {
        title:'Dimensions'
      },
      {
        title:'Pallete'
      }
    ]
  }
  menuItems:NbMenuItem[] = [
    {
      title:'Dimensions'
    },
    {
      title:'Pallete'
    }
  ]
  constructor(private editorService:EditorService) { }

  ngOnInit(): void {
    this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
    this.inputComponent.data = this.menuGroups;
    this.editorService.setInputComponent(this.inputComponent);
    console.log(this.menuGroups)
  }

}
